import { render, staticRenderFns } from "./Simulation.vue?vue&type=template&id=8ac6d0a4&scoped=true"
import script from "./Simulation.vue?vue&type=script&lang=js"
export * from "./Simulation.vue?vue&type=script&lang=js"
import style0 from "./Simulation.vue?vue&type=style&index=0&id=8ac6d0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac6d0a4",
  null
  
)

export default component.exports